import { render, staticRenderFns } from "./juridicalPersonPlanLifeCount.vue?vue&type=template&id=78a58eca&scoped=true&"
import script from "./juridicalPersonPlanLifeCount.vue?vue&type=script&lang=js&"
export * from "./juridicalPersonPlanLifeCount.vue?vue&type=script&lang=js&"
import style0 from "./juridicalPersonPlanLifeCount.vue?vue&type=style&index=0&id=78a58eca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a58eca",
  null
  
)

export default component.exports